import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map } from 'rxjs/operators';

@Injectable()
export class ManageComplaintsService {
  url = environment.configURI;
  load;
  private postManageComplaint = '/newComplaint';
  private complaintPath = '/managecomplaints';
  private complaintViewTasks = '/complaints_view_tasks/';
  private deleteComplaintData: any;
  private editComplaintData: any;

  constructor(private httpClient: HttpClient,
              private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
  }

  /***
   * Post API for a new Complaint
   * @param body
   * @returns {Observable<R|T>}
   */
  submitManageComplaint(body){
    return this.httpClient.post(this.url + this.postManageComplaint, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  /***
   * Update API for a given Complaint
   * @param body
   * @param id
   * @returns {Observable<R|T>}
   */
  updateManageComplaint(body,id){
     return this.httpClient.put(this.url + this.complaintPath + '/' + id, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  /***
   * Delete API to delete a given Complaint
   * @param id
   * @returns {Observable<R|T>}
   */
  deleteManageComplaint(id){
    this.deleteComplaintData = {}
      return this.httpClient.post(this.url + this.complaintPath + '/' + id, this.deleteComplaintData).catch(this.userFriendlyMsgs.errorHandler);
  }

  /***
   * GET API to pull the list of Tasks for a given Complaint based on complaintId
   * @param id
   * @returns {Observable<R|T>}
   */
  viewTasks(id) {
    return this.httpClient.get(this.url + this.complaintViewTasks + id).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/manage-complaints/manage-complaints.service.ts